module.exports = __webpack_public_path__ + "img/mangguo.9b0fde23.jpg";